import type { PortalApi, PortalFlag, PortalInvitation, SharedRecordVM, UploadSlot } from './types.js';
import { FLAG, INVITATION, SHARED_RECORD, UPLOAD_SLOTS } from './fixtures.js';

/**
 * In-memory PortalApi backed by fixtures so the portal is fully interactive offline.
 * Async to match the eventual network impl (HttpApi) — screens cannot tell them apart.
 */
export class FixtureApi implements PortalApi {
  getInvitation(): Promise<PortalInvitation> {
    return Promise.resolve(INVITATION);
  }
  getUploadSlots(): Promise<UploadSlot[]> {
    return Promise.resolve(UPLOAD_SLOTS);
  }
  getFlag(): Promise<PortalFlag> {
    return Promise.resolve(FLAG);
  }
  getSharedRecord(): Promise<SharedRecordVM> {
    return Promise.resolve(SHARED_RECORD);
  }
}
